<template>
    <header id="main-nav-header">
        <div class="logo">
            <a href="/">
                <img
                    alt="logo"
                    src="/images/logos/acclaro-logo-icon-only.png"
                    class="nav-logo"
                    v-tooltip="'Go to Dashboard'"
                    title="Go to Dashboard"
                    data-test="site-logo"
                />
            </a>
        </div>
        <nav id="nav">
            <ul>
                <li v-for="item in items">
                    <span v-if="!item.subnav_items">
                        <a :class="isCurrentPath(item) ? 'activeNav' : ''" v-if="item.url" :href="item.url">
                            {{ item.nav_name }}</a>
                        <span v-else>
                            {{ item.nav_name }}
                        </span>
                    </span>
                    <span
                        v-if="item.subnav_items"
                        v-on:mouseover="mouseover(item)"
                        v-on:mouseleave="mouseleave(item)"
                    >
                        <a :class="isCurrentPath(item) ? 'activeNav' : ''" v-if="item.url" :href="item.url">
                            <div class="flex">{{ item.nav_name }} <chevron-down-icon :size="12"/></div>
                        </a>
                        <ul :class="activeMenu === item.nav_name ? 'isOpen dropdown' : 'dropdown' ">
                            <li v-if="item.nav_name === 'Orders'">
                                <acclaro-recently-viewed v-on:mouseover="mouseover(item)"/>
                            </li>
                            <li
                                v-for="child in item.subnav_items">
                                <a :href="child.route">
                                    {{ child.link_name }}
                                </a>
                            </li>
                        </ul>
                    </span>
                </li>
            </ul>
        </nav>
        <div class="right-main-nav">
            <div v-if="this.role !== 'review_only'" class="flex nav-right-highlight-container">
                <global-search/>
                <div class="">
                    <a @click="createOrder">
                        <button id="nav-create-order" data-test="nav-create-order">
                            <i class="acclaro icon bg-createorder"></i> <span>Create Order</span>
                        </button>
                    </a>
                </div>
            </div>
            <div id="header-nav-icon-container" class="flex flex-row">
                <div class="user-icon-menu" v-if="this.role !== 'review_only'">
                    <a title="Notifications" href="/notifications"
                       style="display: flex; align-items: baseline; width: 27px;"><img
                        data-test="header-img-notifications"
                        src="/images/notifications/notifications-new.svg" class="notification-icon"
                        style="margin-top: 1px;"></a>
                </div>
                <div class="references-icon-link user-icon-menu" v-if="this.role !== 'review_only'">
                    <a title="Account References" href="/references" class="references-icon-link">
                        <img src="/images/ui-icons/references-link-white.svg"
                             data-test="header-img-reference"
                             class="references-icon"></a>
                </div>
                <div class="help-icon-top user-icon-menu" style="margin-right: 10px;" data-test="header-help-icon"
                     v-if="this.role !== 'review_only'">
                    <a href="#" title="Help"><span class="help-icon-top" ></span></a>
                    <ul class="mn-subnav-items">
                        <li class="">
                            <a href="/resources/videos">Help</a></li>
                        <li class=""><a href="/download/pagefile/5">Quick Start
                            Guide</a></li>
                        <li class="">
                            <a href="/resources/videos">Videos</a></li>
                        <li class="">
                            <a href="/resources/documents">Documents</a>
                        </li>
                        <li class="">
                            <a href="/resources/release-notes">Release Notes</a></li>
                        <li class=""><a href="/resources/languages">Languages</a>
                        </li>
                        <li class=""><a
                            href="/settings/about">About My Acclaro</a></li>
                        <li class=""><a
                            href="/settings/announcements">Announcements</a>
                        </li>
                    </ul>
                </div>
                <div class="user-settings-link user-icon-menu" style="margin-top: 5px;">
                    <a href="/settings/userprofile" title="Settings" class="user-settings-link" data-test="header-settings-icon">
                        <span class="acclaro icon bg-settings"></span></a>
                    <ul class="mn-subnav-items">
                        <li><a href="/settings/userprofile">Profile</a></li>
                        <li><a v-if="this.role !== 'review_only'" href="/settings/orders">Orders</a></li>
                        <li><a v-if="this.role !== 'review_only'" href="/settings/email">Email</a></li>
                        <li><a v-if="this.role !== 'review_only'" href="/settings/security">Security</a></li>
                        <li><a v-if="this.role !== 'review_only'" href="/settings/about">About</a></li>
                    </ul>
                </div>
                <div id="authSession" class="ddcontrol active" data-test="header-account-icon">
                    <div id="authSessionOptions" class="autocompletecaf">
                        <div class="res"><a href="/settings/userprofile">Signed in as
                            <b>{{ this.sessionUser.fullName }}</b></a></div>
                        <div class="res"><a href="/logout">Sign Out</a></div>
                        <div class="res"><a
                            href="javascript:showPopupContent('Sign Out from All Devices','600',getLogoutAllContent)">Sign
                            Me out from All Devices</a></div>
                        <div class="res"><a href="/auth-sessions/login-history">View Login
                            History</a></div>
                    </div>
                    <div id="auth-badge">{{
                            this.sessionUser.fullName.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase()
                        }}
                    </div>
                </div>
            </div>
        </div>
        <acclaro-modal v-if="showLogoutWarning" @close="showLogoutWarning = false">
            <div slot="header" class="account-references-preview-modal-header account-references-preview-modal-section">
                <div>
                    <h5>Need more time?</h5>
                </div>
                <div>
                    <div>
                        <i @click="showLogoutWarning = false" class="acclaro-icon ai-close clickable"></i>
                    </div>
                </div>
            </div>
            <div slot="body">
                <div>Your session is about to expire. You will be signed out automatically in: </div>
                <div style="display: flex; justify-content: center; align-items: center;">
                    <input :value="this.warningTimerFormatted" disabled  class="timer"/>
                </div>
                <div>Click <b>Stay Signed In </b> to continue working in My Acclaro</div>
            </div>
            <div slot="footer">
                <button class="button bbutton signOutButton" @click="inactiveUserAction">
                    Sign Out
                </button>
                <button
                    class="bbutton"
                    @click="cancelLogout">
                    Stay Signed In
                </button>
            </div>
        </acclaro-modal>

    </header>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import AcclaroRecentlyViewed from "../Acclaro-Recently-Viewed/AcclaroRecentlyViewed";
import {EventBus} from "../../event-bus";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import AcclaroModal from './../Modal/acclaro-modal.vue';

export default {
    name: "HeaderNav",
    components: {AcclaroRecentlyViewed, ChevronDownIcon, AcclaroModal},
    props: ['items', 'programEnabled'],
    computed: {
        ...mapGetters('AuthStore', [
            'isAdminUser',
            'isAccountManagerRole',
        ]),
        ...mapState('AuthStore', {
            sessionUser: 'user',
            sessionAccount: 'account',
            role: 'role'
        }),
        warningTimerFormatted: function(){
            let s = this.userActivityTimeoutLeft;
            if(s > 0){
                return (s-(s%=60))/60+(9<s?':':':0')+s;
            }
            return ''
        }
    },
    data: function () {
        return {
            showLogoutWarning: false,
            activeMenu: false,
            isInactive: false,
            userActivityTimeoutWarning: null,
            userActivityThrottlerTimeout: null,
            userActivityTimeout: null,
            userActivityTimeoutLeft: 120
        }
    },
    beforeMount() {
        this.activateActivityTracker();
    },
    beforeDestroy() {
        this.deActivateActivityTracker()

        clearTimeout(this.userActivityTimeout);
        clearTimeout(this.userActivityThrottlerTimeout);
        clearTimeout(this.userActivityTimeoutWarning);
    },
    methods: {
        mouseover: function (item) {
            this.activeMenu = item.nav_name;
        },
        mouseleave: function () {
            EventBus.$emit('toggle-recently-viewed-orders')
            this.activeMenu = undefined;
        },
        isCurrentPath(item) {
            return window.location.href.split('?')[0] === item.url;
        },
        cancelLogout(){
            this.userActivityTimeoutLeft = 120 // seconds
            this.showLogoutWarning = false
            this.activateActivityTracker()
            clearTimeout(this.userActivityTimeoutWarning)
        },
        userActivityThrottler() {
            if (!this.userActivityThrottlerTimeout) {
                this.userActivityThrottlerTimeout = setTimeout(() => {
                    this.resetUserActivityTimeout();
                    this.userActivityThrottlerTimeout = null;
                    this.userActivityTimeoutLeft = 120
                    clearTimeout(this.userActivityThrottlerTimeout);
                }, 3600000);
            }
        },
        resetUserActivityTimeout() {
            clearTimeout(this.userActivityTimeout);
            this.userActivityTimeout = setTimeout(() => {
                this.showLogoutWarning = true
                this.logoutCountDownTimer();
            }, 3600000); // 1 hour
        },
        logoutCountDownTimer () {
            clearTimeout(this.userActivityTimeoutWarning)
            this.deActivateActivityTracker()
            if(!this.showLogoutWarning)
            {
                return;
            }
            this.userActivityTimeoutWarning = setTimeout(() => {
                this.userActivityTimeoutLeft -= 1
                if(this.userActivityTimeoutLeft > 0){
                    this.logoutCountDownTimer()
                } else {
                    this.inactiveUserAction()
                }
            }, 1000)
        },
        inactiveUserAction() {
            window.location = '/logout?session_time_out=true'
        },
        activateActivityTracker() {
            window.addEventListener("mousemove", this.userActivityThrottler);
            window.addEventListener("scroll", this.userActivityThrottler);
            window.addEventListener("keydown", this.userActivityThrottler);
            window.addEventListener("resize", this.userActivityThrottler);
        },
        deActivateActivityTracker() {
            window.removeEventListener("mousemove", this.userActivityThrottler);
            window.removeEventListener("scroll", this.userActivityThrottler);
            window.removeEventListener("keydown", this.userActivityThrottler);
            window.removeEventListener("resize", this.userActivityThrottler);
        },
        getProgramSelectionPopupSetting() {
            let type = 'ordercreate', key = 'show-popup';

            return new Promise((resolve, reject) => {
                axios.get(`/users/preference/${type}/${key}`).then((response) => {
                    let showPopupContent = false;
                    if(response && response.data) {
                        showPopupContent = response.data.value === "1" ? true : false;
                    }
                    resolve(showPopupContent);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        async createOrder(e) {
            /**
             * Do not show program selection pop up if it is disabled
             * or program is disabled
             */
            let showPopupContent = await this.getProgramSelectionPopupSetting();

            if(showPopupContent && this.programEnabled) {
                window.showing = '#popup';
                $("#popup").css('max-width', '500px');
                $("#popup").css('min-width', '500px');
                $('#popup').load('/orders/create-with-program-view');
                $('#popup').show();
                $('#layermask').show();
                e.preventDefault();
            } else {
                return window.location.href = '/orders/create';
            }
        }
    }
}
</script>

<style scoped>

#main-nav-header {
    width: 100%;
    display: flex;
    height: 55px;
    background-color: #005288;
    align-items: center;
    justify-content: flex-end;
}

#nav {
    display: flex;
    align-items: self-end;
    justify-content: flex-start;
    width: 100%;
    background: #005288;
    margin: 0 auto;
    font-size: 14px;
}

.right-main-nav {
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    display: flex;
    background: #005288;
}

#nav > ul {
    display: flex;
    margin: 0;
    max-height: 40px;
    list-style-type: none;
    align-items: center;
    padding: 15px;
}

#nav > ul > li > span {
    position: relative;
    display: block;
    padding: 18px 8px;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
}

#nav > ul > li > span > a {
    color: #B2CADB;
}

#nav > ul > li > span {
    position: relative;
    display: block;
    height: auto;
    padding: 18px 8px;
    color: #B2CADB;
    text-decoration: none;
    cursor: pointer;
    font-weight: 200;
}

.dropdown {
    position: absolute;
    top: 43px;
    left: 9px;
    display: none;
    padding: 0;
    z-index: 99999;
    list-style-type: none;
    background-color: #FFF;
}

.dropdown li {
    border-bottom: 1px solid #eeeeee;
}

.dropdown li a {
    width: 100%;
    display: block;
    padding: 9px;
    color: #333333;
    text-decoration: none;
}

.activeNav {
    color: white !important;
}

.isOpen {
    font-weight: 200;
    display: block;
    width: 240px;
    border-radius: 2px;
}

.signOutButton {
    color: #2769A5;
    background: #fff;
    border: 1px solid #2769A5;
}

.timer {
    font-size: 30px;
    width: 100px;
    font-weight: 500;
    margin: 10px;
    text-align: center;
}

#header-nav-icon-container {
    display: flex;
    align-items: center;
}

</style>
